/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_History_Top_CountriesInputs */

const en_admin_funnel_history_top_countries = /** @type {(inputs: Admin_Funnel_History_Top_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top countries (visits)`)
};

/**
* | output |
* | --- |
* | "Top countries (visits)" |
*
* @param {Admin_Funnel_History_Top_CountriesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_history_top_countries = /** @type {((inputs?: Admin_Funnel_History_Top_CountriesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_History_Top_CountriesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_history_top_countries(inputs)
});
export { admin_funnel_history_top_countries as "admin.funnel.history.top_countries" }